import { css } from "styled-components";

export default css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
  }

  html,
  body {
    height: 100%;
  }

  body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }
  a {
    color: #0284c9;
  }
  .section-pullup {
    position: relative;
    top: -80px;
    width: 100%;
  }
  @media only screen and (min-width: 992px) {
    .section-pullup {
      padding-bottom: 50px;
      top: -50px;
    }
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  @media only screen and (max-width: 767px) {
    .hidden-xs {
      display: none !important;
    }
  }

  body.loading-indicator,
  body.loading-indicator-api {
    overflow: hidden !important;
  }
  body.loading-indicator:before,
  body.loading-indicator-api:before {
    content: "";
    background: #f6f6f694;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9998;
  }

  body.loading-indicator:after,
  body.loading-indicator-api:after {
    content: "";
    background-image: url("/app-tracker/assets/images/ManipalCigna-Loder.gif");
    background-size: contain;
    position: fixed;
    width: 150px;
    height: 150px;
    top: calc(50% - 75px);
    left: calc(50% - 75px);
    z-index: 9999;
    text-align: center;
  }

  .form-content-wrapper .ant-form-item-row {
    display: block;
  }
  .required-marker {
    color: red;
    padding: 0 3px;
    top: -4px;
    position: relative;
    font-size: 15px;
  }
`;
